import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import { useFeatureFlagEnabled } from 'posthog-js/react';

const FF_DOCUMENT_READER = 'document_reader';

const DocumentReaderLayout = () => {
	const enabled = useFeatureFlagEnabled(FF_DOCUMENT_READER);

	// `undefined` while PostHog is still loading its flags: render nothing rather
	// than redirecting away before the flag resolves.
	if (enabled === undefined) {
		return null;
	}

	if (!enabled) {
		return <Navigate to="/" />;
	}

	return <Outlet />;
};

export const Route = createFileRoute('/_protected/document-reader')({
	component: DocumentReaderLayout,
});
